export function hasTextContent(content: string | undefined): boolean {
	if (!content) return false;
	if (content[0] === '{' || content[0] === '[') {
		const contentJson = JSON.parse(content);
		if (!contentJson || !contentJson.blocks) return false;
		contentJson.blocks = contentJson.blocks.filter(
			(block) => block.type !== 'paragraph' || block.data.text.trim().length > 0
		);
		return contentJson.blocks.length > 0;
	} else {
		return content.trim().length > 0;
	}
}
